import React from 'react';

interface StatCardProps {
  /** one of your theme colours: 'blue' | 'green' | 'yellow' | 'red' */
  color: 'blue' | 'green' | 'yellow' | 'red';
  /** e.g. 'clock', 'circle-check', etc. (without the `ti-` prefix) */
  icon: string;
  title: string;
  value: string | number;
}

// map our “semantic” palette names to your existing text‐color classes
const TEXT_COLOR_MAP: Record<StatCardProps['color'], string> = {
  blue:   'text-blue',
  green:  'text-success',
  yellow: 'text-warning',
  red:    'text-danger',
};

const StatCard: React.FC<StatCardProps> = ({ color, icon, title, value }) => {
  const textColorClass = TEXT_COLOR_MAP[color];

  return (
    <div className={`card stats-card stats-card-${color} w-100`}>
      <div className="card-body">
        <div className="db-widgets d-flex justify-content-between align-items-center">
          <div className="db-info">
            <h6 className="stats-title text-none">{title}</h6>
            <h3 className={`stats-value ${textColorClass}`}>
              {value}
            </h3>
          </div>
          <div className={`db-icon-container icon-${color}`}>
            <i className={`ti ti-${icon} stats-icon`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatCard;
